/*eslint-disable*/
import React, { useContext, useEffect, useState } from "react";
import { Calendar as BigCalendar, dateFnsLocalizer } from "react-big-calendar";
import format from "date-fns/format";
import getDay from "date-fns/getDay";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { FirebaseContext } from "common";
import { useSelector } from "react-redux";
import {
  Card,
  CardBody,
  Row,
  Col,
} from "reactstrap";
import { useNavigate } from "react-router-dom";

const locales = {
  "en-US": require("date-fns/locale/en-US"),
};
const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

export default function DoctorCalendar() {
  const { api } = useContext(FirebaseContext);
  const { addBooking } = api;
  const bookinglistdata = useSelector((state) => state.bookinglistdata);
  const auth = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const [allEvents, setAllEvents] = useState([]);

  useEffect(() => {
    if (bookinglistdata.bookings && auth?.info?.uid) {
      const eventlist = bookinglistdata.bookings
        .filter((b) => b?.doctor?.uid === auth.info.uid) // only show this doctor's bookings
        .map((booking) => {
          // expired check
          let status = booking.status;
          if (
            booking.status === "ACCEPTED" &&
            booking.endDate &&
            new Date().getTime() > new Date(booking.endDate).getTime() + 30 * 60 * 1000
          ) {
            status = "EXPIRED";
          }

          return {
            ...booking,
            title: `${booking.serviceType} - ${booking.patientName}`,
            start: new Date(booking.eventDate),
            end: new Date(booking.endDate),
            status,
          };
        });

      setAllEvents(eventlist);
    }
  }, [bookinglistdata, auth]);

  // colour coding by status
  const eventColors = (event) => {
  const statusColors = {
    NEW: "#ff0000",       // red
    PENDING: "#6f42c1",   // purple
    ACCEPTED: "#28a745",  // green
    COMPLETE: "#007bff", // blue
    EXPIRED: "#6c757d",   // gray
  };
    return {
      style: {
        backgroundColor: statusColors[event.status] || "#000",
        borderRadius: "6px",
        opacity: 0.9,
        color: "white",
        border: "0px",
        display: "block",
      },
    };
  };

  const selectedEvent = (Booking) => {
    // don't allow navigation for expired bookings
    if (Booking.status !== "EXPIRED") {
      navigate("/bookinginformation", { state: { Booking } });
    }
  };

  return (
    <div className="content">
      <Row>
        <Col md="12">
          <Card>
            <CardBody>
              <BigCalendar
                selectable
                localizer={localizer}
                events={allEvents}
                step={15}
                timeslots={1}
                startAccessor="start"
                endAccessor="end"
                defaultView="month"
                scrollToTime={new Date(1970, 1, 1, 6)}
                defaultDate={new Date()}
                onSelectEvent={selectedEvent}
                eventPropGetter={eventColors} // 🔑 apply colour coding
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
